document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initMarquesina();
  initGaleriaProducto();
  initCantidad();
  initOpcionesProducto();
});

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-lt-galeria]');
  if (!galeria) return;
  var minis = galeria.querySelectorAll('[data-lt-mini]');
  var imagenes = galeria.querySelectorAll('[data-lt-imagen-principal]');
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var indice = mini.getAttribute('data-indice');
      minis.forEach(function (m) { m.classList.remove('lt-galeria-mini-activa'); });
      mini.classList.add('lt-galeria-mini-activa');
      imagenes.forEach(function (img) {
        img.classList.toggle('lt-galeria-imagen-activa', img.getAttribute('data-indice') === indice);
      });
    });
  });
}

function initCantidad() {
  var cajas = document.querySelectorAll('[data-lt-form-producto]');
  cajas.forEach(function (form) {
    var input = form.querySelector('[data-lt-cantidad]');
    var menos = form.querySelector('[data-lt-menos]');
    var mas = form.querySelector('[data-lt-mas]');
    if (!input || !menos || !mas) return;
    menos.addEventListener('click', function () {
      var v = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = v;
    });
    mas.addEventListener('click', function () {
      var v = Math.max(1, parseInt(input.value || '1', 10) + 1);
      input.value = v;
    });
  });
}

function initOpcionesProducto() {
  var forms = document.querySelectorAll('[data-lt-form-producto]');
  forms.forEach(function (form) {
    var variantesScript = form.querySelector('[data-lt-variantes]');
    if (!variantesScript) return;
    var variantes;
    try {
      variantes = JSON.parse(variantesScript.textContent);
    } catch (e) {
      return;
    }
    var grupos = form.querySelectorAll('[data-lt-opcion]');
    var idInput = form.querySelector('[data-lt-variant-id]');
    var precioCaja = form.closest('.lt-producto-compra') || form.parentElement;
    var precioEl = precioCaja ? precioCaja.querySelector('[data-lt-precio]') : null;
    var precioAntesEl = precioCaja ? precioCaja.querySelector('[data-lt-precio-antes]') : null;
    var descuentoEl = precioCaja ? precioCaja.querySelector('[data-lt-descuento]') : null;
    var botonComprar = form.querySelector('[data-lt-boton-comprar]');
    var botonTexto = form.querySelector('[data-lt-boton-texto]');

    function seleccionActual() {
      var seleccion = [];
      grupos.forEach(function (grupo) {
        var activo = grupo.querySelector('.lt-opcion-valor-activa');
        seleccion.push(activo ? activo.getAttribute('data-lt-valor') : null);
      });
      return seleccion;
    }

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
    }

    function actualizar() {
      var seleccion = seleccionActual();
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatearDinero(variante.price);
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        if (precioAntesEl) { precioAntesEl.textContent = formatearDinero(variante.compare_at_price); precioAntesEl.style.display = ''; }
        if (descuentoEl) {
          var pct = Math.round(((variante.compare_at_price - variante.price) / variante.compare_at_price) * 100);
          descuentoEl.textContent = '-' + pct + '%';
          descuentoEl.style.display = '';
        }
      } else {
        if (precioAntesEl) precioAntesEl.style.display = 'none';
        if (descuentoEl) descuentoEl.style.display = 'none';
      }
      if (botonComprar) botonComprar.disabled = !variante.available;
      if (botonTexto) botonTexto.textContent = variante.available ? (botonComprar.getAttribute('data-texto-disponible') || botonTexto.textContent) : (botonComprar.getAttribute('data-texto-agotado') || 'Agotado');
    }

    grupos.forEach(function (grupo) {
      grupo.querySelectorAll('[data-lt-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('[data-lt-valor]').forEach(function (b) { b.classList.remove('lt-opcion-valor-activa'); });
          btn.classList.add('lt-opcion-valor-activa');
          actualizar();
        });
      });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.lt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('lt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-lt-contador]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-lt-contador')) || 0;
      obs.unobserve(el);
      if (reduced) {
        el.textContent = target;
        return;
      }
      var duration = 1400;
      var start = null;
      function paso(ts) {
        if (!start) start = ts;
        var progreso = Math.min((ts - start) / duration, 1);
        var valor = Math.floor(progreso * target);
        el.textContent = valor.toLocaleString('es-ES');
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = target.toLocaleString('es-ES');
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesina() {
  var wraps = document.querySelectorAll('[data-lt-marquesina]');
  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('.lt-marquesina-track');
    if (!track || track.dataset.duplicado) return;
    track.innerHTML += track.innerHTML;
    track.dataset.duplicado = '1';
  });
}
